import { gql } from '@apollo/client';

export const HANDLE_BAG_MERGE_EVENT = gql`
  mutation HandleBagMergeOldEvent($input: OldBagMergeInput!) {
    handleBagMergeOldEvent(input: $input) {
      success
      mergeTaskId
      totalOrderCount
      totalBagCount
      targetBagNumber
      bagBreakdown {
        bagId
        bagNumber
        orderCount
        isTarget
      }
    }
  }
`;

export interface BagMergeInput {
  sourceBagIds: number[];
  targetBagId: number;
}

export interface BagMergeBagBreakdownType {
  bagId: number;
  bagNumber: string;
  orderCount: number;
  isTarget: boolean;
}

export interface OldBagMergeResultType {
  success: boolean;
  mergeTaskId: number;
  totalOrderCount: number;
  totalBagCount: number;
  targetBagNumber: string;
  bagBreakdown: BagMergeBagBreakdownType[];
}

export interface HandleBagMergeOldEventResponse {
  handleBagMergeOldEvent: OldBagMergeResultType;
}

export interface HandleBagMergeEventVariables {
  input: BagMergeInput;
}
